require('./list.jade')
_ = require("lodash")

ListDirective = ->
  restrict: "A"
  replace: false
  transclude: true
  templateUrl: "score-registration/select-club/list.jade"
  scope:
    selectClub: '&onClubSelected'
    loadClub: '&onLoadClub'
    preload: "=?"
    isLoading: "=?"
    isHistory: "=?"
    mailTo: "=?"
  link: (scope, element, attrs, ctrl, transclude) ->
    currentPage = undefined
    totalPages = undefined
    scope.clubs = []
    scope.hasNoResult = false
    scope.isLoading = false

    scope.loadMore = ->
      currentPage++
      loadMore()

    scope.hasMore = ->
      totalPages and (currentPage isnt totalPages)

    scope.isSearched = ->
      currentPage >= 1

    scope.showAddressCountry = (club) ->
      if club.address and club.country
        return club.address + ', ' + club.country
      else if not club.address and club.country
        return club.country
      else
        return club.address

    loadMore = ->
      scope.isLoading = true
      scope.loadClub()(currentPage)
      .then (resp) ->
        if resp.data.total_pages is 0
          scope.hasNoResult = true
        else
          totalPages = resp.data.total_pages
          scope.hasNoResult = false
          scope.clubs = _.union(scope.clubs, resp.data.clubs)
      .finally ->
        scope.isLoading = false

    scope.$on "reloadClub.gnp.scoreRegistration", ->
      currentPage = 1
      totalPages = undefined
      scope.clubs = []
      loadMore()

    if scope.preload
      currentPage = 1
      loadMore()

    #force transclude section to use isolated scope
    transclude scope, (clone, scope) ->
      element.find(".custom-place").append(clone)



module.exports = ListDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/select-club/list-directive.coffee